import { useEffect, useMemo } from 'react';
import thunkActions from '../../store/actions/thunkActions';
import { AppDispatch } from '../../../common/store';
import { useDispatch } from 'react-redux';
import carUrlQueryTransformer from '../../../common/service/carUrlQueryTransformer';
import { useLocation, useParams } from 'react-router';
import IParams from '../../../gqlCustomise/model/IParams';

const useCustomiseOptions = () => {
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { carId } = useParams<IParams>();
  const latestCustomisedCar = useMemo(() => carUrlQueryTransformer.fromQueryString(carId, location), [carId, location]);

  useEffect(() => {
    if (latestCustomisedCar?.carId) {
      dispatch(thunkActions.fetchOptions({ carId: latestCustomisedCar.carId }));
    }
  }, [dispatch, carId]);
};

export default useCustomiseOptions;
